// extracted by mini-css-extract-plugin
export default {"loginWrapper":"style_loginWrapper__smP7A"};